// Product page: fits-list filter + full-screen photo viewer. Site: hover prefetch,
// service worker (installable app / offline page).
import { $, $$, esc, icon, t } from "./util";

function fitsFilter() {
	const q = $("[data-fits-q]");
	if (!q) return;
	q.addEventListener("input", () => {
		const n = q.value.trim().toLowerCase();
		$$("[data-fit]").forEach((a) => (a.hidden = !!n && !a.dataset.fit.includes(n)));
	});
}

function lightbox() {
	const main = $("[data-gallery-main]");
	if (!main) return;
	const zoomBox = main.closest("[data-zoom]");
	const open = () => {
		const srcs = $$("[data-thumb]").map((b) => b.dataset.thumb);
		const list = srcs.length ? srcs : [main.src];
		let i = Math.max(0, list.indexOf(main.getAttribute("src")));
		const box = document.createElement("div");
		box.className = "ds-lightbox"; box.setAttribute("role", "dialog"); box.setAttribute("aria-modal", "true");
		const paint = () => { box.querySelector("img").src = list[i]; box.querySelector(".ds-lightbox__n").textContent = `${i + 1} / ${list.length}`; };
		box.innerHTML = `<img alt=""><button type="button" class="ds-lightbox__x" aria-label="${t("إغلاق", "Close")}">${icon("x")}</button>
			${list.length > 1 ? `<button type="button" class="ds-lightbox__p" aria-label="prev">${icon("chevron")}</button><button type="button" class="ds-lightbox__nx" aria-label="next">${icon("chevron")}</button>` : ""}
			<span class="ds-lightbox__n"></span>`;
		document.body.appendChild(box); document.documentElement.style.overflow = "hidden"; paint();
		const close = () => { box.remove(); document.documentElement.style.overflow = ""; document.removeEventListener("keydown", key); };
		const step = (d) => { i = (i + d + list.length) % list.length; paint(); };
		const key = (e) => { if (e.key === "Escape") close(); if (e.key === "ArrowRight") step(document.dir === "rtl" ? -1 : 1); if (e.key === "ArrowLeft") step(document.dir === "rtl" ? 1 : -1); };
		document.addEventListener("keydown", key);
		box.addEventListener("click", (e) => {
			if (e.target.closest(".ds-lightbox__x") || e.target === box) close();
			if (e.target.closest(".ds-lightbox__p")) step(-1);
			if (e.target.closest(".ds-lightbox__nx")) step(1);
			if (e.target.tagName === "IMG") e.target.classList.toggle("is-zoom");
		});
	};
	// double-click (desktop) or tap (touch) opens the full-screen viewer; single click keeps the inline zoom
	zoomBox?.addEventListener("dblclick", open);
	if (window.matchMedia("(hover: none)").matches) zoomBox?.addEventListener("click", open);
	const btn = document.createElement("button");
	btn.type = "button"; btn.className = "ds-fullbtn"; btn.setAttribute("aria-label", t("عرض بملء الشاشة", "Full screen"));
	btn.innerHTML = `<svg class="di" viewBox="0 0 24 24"><path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/></svg>`;
	btn.addEventListener("click", (e) => { e.stopPropagation(); open(); });
	zoomBox?.appendChild(btn);
}

function prefetch() {
	if (!("IntersectionObserver" in window) || navigator.connection?.saveData) return;
	const done = new Set();
	let timer;
	document.addEventListener("pointerover", (e) => {
		const a = e.target.closest("a[href^='/']");
		if (!a || a.target || a.hasAttribute("download") || /\/(api|app|files)\//.test(a.getAttribute("href"))) return;
		clearTimeout(timer);
		timer = setTimeout(() => {
			const href = a.getAttribute("href");
			if (done.has(href) || done.size > 30) return;
			done.add(href);
			const l = document.createElement("link"); l.rel = "prefetch"; l.href = href; document.head.appendChild(l);
		}, 80);
	}, { passive: true });
}

function serviceWorker() {
	if (!("serviceWorker" in navigator) || location.protocol !== "https:") return;
	addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch(() => {}));
}

export function initExtras() { fitsFilter(); lightbox(); prefetch(); serviceWorker(); }
